import {createResourceReducer} from 'src/shared/utils/resource';
import {
  LOAD_SMS_ENROLLMENT_START,
  LOAD_SMS_ENROLLMENT_COMPLETE,
  LOAD_SMS_ENROLLMENT_SUCCESS,
  LOAD_SMS_ENROLLMENT_ERROR,
  CREATE_OUTAGE_SMS_ENROLLMENT_START,
  CREATE_OUTAGE_SMS_ENROLLMENT_SUCCESS,
  CREATE_OUTAGE_SMS_ENROLLMENT_ERROR,
  CREATE_OUTAGE_SMS_ENROLLMENT_COMPLETE,
} from 'src/shared/smsEnrollment/actions';

export const smsEnrollment = createResourceReducer({
  start: LOAD_SMS_ENROLLMENT_START,
  complete: LOAD_SMS_ENROLLMENT_COMPLETE,
  success: LOAD_SMS_ENROLLMENT_SUCCESS,
  error: LOAD_SMS_ENROLLMENT_ERROR,
});
export const outageSmsEnrollment = createResourceReducer({
  start: CREATE_OUTAGE_SMS_ENROLLMENT_START,
  success: CREATE_OUTAGE_SMS_ENROLLMENT_SUCCESS,
  error: CREATE_OUTAGE_SMS_ENROLLMENT_ERROR,
  complete: CREATE_OUTAGE_SMS_ENROLLMENT_COMPLETE,
});
